import React, { useState } from 'react';
import {
    Box,
    Stack,
    Chip,
    Typography,
    Tooltip,
    IconButton,
    Paper
} from '@mui/material';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import HistoryIcon from '@mui/icons-material/History';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const SearchHistory = ({
    searchHistory,
    onHistoryClick,
    onClearHistory,
    onDeleteHistoryItem,
    selectedHistoryIndex,
    setSelectedHistoryIndex
}) => {

    const [isLoading, setIsLoading] = useState(false);

    const handleHistoryClick = async (item, index) => {
        setIsLoading(true);
        setSelectedHistoryIndex(index);
        try {
            await onHistoryClick(item);
        } finally {
            setIsLoading(false);
        }
    };

    if (searchHistory.length === 0) return null;

    return (
        <Paper
            elevation={0}
            sx={{
                px: 1,
                backgroundColor: 'transparent',
                borderRadius: 2,
                mb: 0,
                py: 0
            }}
        >
            <Stack
                direction="row"
                spacing={1}
                sx={{
                    flexWrap: 'wrap',
                    gap: 1.5,
                    alignItems: 'center'
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Tooltip title="Clear History">
                        <span>
                            <IconButton
                                onClick={onClearHistory}
                                color="error"
                                size="small"
                                disabled={isLoading}
                                sx={{
                                    ml: 1,
                                    '&:hover': {
                                        backgroundColor: 'error.lighter'
                                    }
                                }}
                            >
                                <DeleteSweepIcon fontSize="small" />
                            </IconButton>
                        </span>
                    </Tooltip>
                </Box>

                {searchHistory.map((item, index) => (
                    <Stack
                        key={item.id}
                        direction="row"
                        spacing={1}
                        alignItems="center"
                    >
                        <Chip
                            label={`${item.params.value === 2 ? '"' : ''}${item?.params?.title?.substring(0, 50)}${item.params.title.length > 50 ? '...' : ''}${item.params.value === 2 ? '"' : ''}`}
                            onClick={() => handleHistoryClick(item, index)}
                            disabled={isLoading}
                            sx={{
                                maxWidth: 300,
                                height: 32,
                                backgroundColor: index === selectedHistoryIndex && !isLoading
                                    ? 'rgba(94, 79, 170, 1)'
                                    : 'background.paper',
                                color: index === selectedHistoryIndex && !isLoading
                                    ? '#fff'
                                    : 'text.primary',
                                '&:hover': {
                                    backgroundColor: index === selectedHistoryIndex && !isLoading
                                        ? 'rgba(94, 79, 170, 1)'
                                        : isLoading ? 'background.paper' : 'action.hover',
                                },
                                '&.Mui-disabled': {
                                    opacity: 0.6,
                                    cursor: 'not-allowed',
                                    backgroundColor: index === selectedHistoryIndex
                                        ? 'rgba(94, 79, 170, 1)'
                                        : 'background.paper',
                                    color: index === selectedHistoryIndex
                                        ? '#fff'
                                        : 'text.primary',
                                },
                                '& .MuiChip-label': {
                                    whiteSpace: 'nowrap',
                                    fontWeight: 500,
                                    fontSize: '0.875rem'
                                },
                                transition: 'all 0.3s ease'
                            }}
                        />
                        {index < searchHistory.length - 1 && (
                            <ArrowForwardIosIcon
                                sx={{
                                    color: 'text.secondary',
                                    fontSize: 14,
                                    mx: 0.5
                                }}
                            />
                        )}
                    </Stack>
                ))}
            </Stack>
        </Paper>
    );
};

export default SearchHistory;